import omit from 'lodash/omit'
import { SaleAdjustment } from '../../../../types/adjustments'
import { lineItemToJSON } from '../../../functions/lineItem'
import { LineItem } from '../../../models/line-item'
import { paymentToJSON } from '../../../models/payment'
import { SaleJson } from '../../../models/sale'
import { saleDiscountToJSON } from '../../../models/sale-discount'
import { ReduxCurrentSale } from './currentSaleSlice'

export class ReduxSaleStorageAdapter {
  public readonly status: typeof this.sale.status
  public readonly syncStatus: typeof this.sale.syncStatus
  public readonly saleDate: typeof this.sale.saleDate

  constructor(
    private readonly sale: ReduxCurrentSale,
    public readonly lineItems: LineItem[]
  ) {
    this.status = sale.status
    this.syncStatus = sale.syncStatus
    this.saleDate = sale.saleDate
  }

  /**
   * Returns a JSON representation of this sale suitable for storing in IndexedDB. Referenced models
   * are either replaced with their respective IDs (e.g. customer) or converted to their JSON
   * equivalent (e.g. line item).
   *
   * @return JSON representation of this sale
   */
  public toJSON(): SaleJson {
    const adjustmentToJSON = ({ type, ...rest }: SaleAdjustment) => {
      return {
        adjustment_type: type,
        ...rest,
      }
    }

    return {
      ...omit(this.sale, 'customer', 'user', 'customerBalances'),
      ...omit(this, 'sale'),
      lineItems: this.lineItems.map(lineItemToJSON),
      payments: this.sale.payments.map(paymentToJSON),
      discount: this.sale.discount && saleDiscountToJSON(this.sale.discount),
      change: this.sale.change && paymentToJSON(this.sale.change),
      customer_id: this.sale.customer && this.sale.customer.id,
      user_id: this.sale.user && this.sale.user.id,
      adjustments: this.sale.adjustments.map(adjustmentToJSON),
      originalSurcharge: this.sale.originalSurcharge,
      ecomCustomCharges: this.sale.ecomCustomCharges,
    }
  }
}
